import { css } from '@emotion/core'
import parse from 'html-react-parser'
import * as React from 'react'

import { breakpoints } from '../../../constants/breakPoints'
import { isDesktop } from '../../../helpers/common'
import { LearnCategoriesMenuProps } from '../../../interfaces/learn'
import Grid from './../../Grid'
import SearchBar from './../../Search'
import LearnCategoryTab from './LearnCategoryTab'

export const LearnCategoriesMenu: React.FunctionComponent<LearnCategoriesMenuProps> = ({
  isHero = false,
  headlineText,
  subheaderText,
  categories,
  cssStyles,
  search = '',
  setSearch = () => {},
  withoutBorder = false,
  withoutPadding = false,
  skipCategory,
}) => {
  return (
    <div className={'full-screen-relative'} css={[containerStyle(withoutBorder, withoutPadding), cssStyles]}>
      <Grid columns={2} columnsTemplate={'auto max-content'} columnGap={3} rowGap={0.75} cssStyles={gridStyle}>
        <div css={titleDescriptionStyle}>
          {isHero ? (
            <h1 className={'heading2 white-text'}>{parse(headlineText)}</h1>
          ) : (
            <h2 className={'heading2 white-text'}>{parse(headlineText)}</h2>
          )}
          {subheaderText && (
            <div css={introSubtitleStyle} className={'subtitle white-text'}>
              {parse(subheaderText)}
            </div>
          )}
          {isHero && isDesktop(breakpoints.large + 1) && (
            <SearchBar
              blackBG
              isInSidebar
              search={search}
              setSearch={setSearch}
              placeholder={'Search articles...'}
              cssStyles={searchBarStyle}
            />
          )}
        </div>

        {categories && (
          <Grid
            columns={2}
            columnGap={3}
            columnsTemplate={'max-content max-content'}
            rowGap={0.75}
            noBreakForTablet
            cssStyles={learnCategoriesGridStyle(!!(headlineText || subheaderText))}
          >
            {categories.edges.map(
              ({ node: { slug, name, categoryColor, categoryLogo } }) =>
                skipCategory !== name && (
                  <LearnCategoryTab
                    logoSrc={categoryLogo}
                    title={name}
                    stripColor={categoryColor}
                    url={`/product-learn/category/${slug}/`}
                    key={slug}
                  />
                )
            )}
          </Grid>
        )}
      </Grid>
    </div>
  )
}

export const containerStyle = (withoutBorder: boolean, withoutPadding: boolean) => css`
  position: relative;
  ${!withoutPadding &&
  `
    padding-top: 6rem;
    padding-bottom: 6rem;
  `};
  margin-bottom: 4rem;
  color: #000;
  ${!withoutBorder && 'border-bottom: 1px solid rgba(136, 146, 158, 0.4)'};

  .heading2 {
    margin-bottom: 0 !important;
  }

  @media screen and (max-width: ${breakpoints.large}px) {
    .heading2,
    .subtitle {
      text-align: center !important;
    }

    ${!withoutPadding &&
    `
      padding-top: 3rem;
      padding-bottom: 3rem;
      `};
  }

  @media screen and (max-width: ${breakpoints.medium}px) {
    margin-bottom: 3rem;
  }
`

const gridStyle = css`
  row-gap: 2rem;

  @media screen and (max-width: ${breakpoints.large}px) {
    grid-template-columns: 1fr;
  }
`

const learnCategoriesGridStyle = (withHeading?: boolean) => css`
  margin-left: 1.5rem;

  ${withHeading && 'margin-top: 1rem'};

  @media screen and (max-width: ${breakpoints.large}px) {
    width: auto;
    margin-left: auto;
    margin-right: auto;
    transform: translateX(0.75rem);
  }
`

const searchBarStyle = css`
  margin-top: 2rem !important;
  max-width: 20rem;

  @media screen and (max-width: ${breakpoints.large}px) {
    margin-left: auto !important;
    margin-right: auto !important;
    max-width: 25rem;
  }
`

const titleDescriptionStyle = css`
  @media screen and (max-width: ${breakpoints.large}px) {
    margin-left: auto;
    margin-right: auto;
  }
`

const introSubtitleStyle = css`
  max-width: 560px;

  @media screen and (max-width: ${breakpoints.medium}px) {
    margin-left: auto !important;
    margin-right: auto !important;
    text-align: center;
  }
`
